import React, { useState, useRef, useEffect } from 'react';
import { Tooltip as TooltipLite } from 'react-tooltip';

const SalesMappedUser = ({agencyList, mappedUserIds = [],onChange}:any) => {
  
  const tipContentRef = useRef(null);
  const buttonRef = useRef(null);
  const [tipOpen, setTipOpen] = useState(false);
  const [availableUsers, setAvailableUsers] = useState<any[]>([]);
  const [mappedUsers, setMappedUsers] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [searchTermRight, setSearchTermRight] = useState("");
  const [openTooltipId, setOpenTooltipId] = useState(null);


  // set all agency user

  useEffect(() => {
    const handleClick = () => setOpenTooltipId(null);
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
}, []);


  useEffect(() => {
    if (agencyList?.length) {
      const mapped = agencyList.filter((u: any) =>
        mappedUserIds.includes(u.value)
      );
      const available = agencyList.filter(
        (u: any) => !mappedUserIds.includes(u.value)
      );
if (mappedUsers.length === 0) {
      setMappedUsers(mapped);
      setAvailableUsers(available);
    }
      //setMappedUsers(mapped);
      //setAvailableUsers(available);
    }
  }, [agencyList, mappedUserIds.join(",")]);

  
  useEffect(() => {
    if (onChange) {
      onChange(mappedUsers); 
    }
  }, [mappedUsers]);

  const toggleTip = () => {
    setTipOpen((prev) => !prev);
  };

  const bodyClick = (e:any) => {
   // console.log(tipContentRef);
    // if ((tipContentRef.current && tipContentRef.current.contains(e.target)) || (buttonRef.current && buttonRef.current.contains(e.target))) {
    //   return;
    // }
    setTipOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', bodyClick);
    return () => {
      document.removeEventListener('mousedown', bodyClick);
    };
  }, []);


  // move user left -> right
  const handleMapUser = (user: any) => {
    setAvailableUsers((prev) => prev.filter((u) => u.value !== user.value));
    setMappedUsers((prev) => [...prev, user]);
  };

  // move user right -> left
  const handleUnmapUser = (user: any) => {
    setMappedUsers((prev) => prev.filter((u) => u.value !== user.value));
    setAvailableUsers((prev) => [...prev, user]);
  };

  const filteredUsers = availableUsers.filter((user) =>
    user.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredMappedUsers = mappedUsers.filter((user) =>
  user.label.toLowerCase().includes(searchTermRight.toLowerCase())
);
  
console.log('agencyList=',agencyList);
  return (
    <React.Fragment>
      <div className="sales-users-left-panel">
        <h3>Agency Name</h3>
        <div className="sales-mapped-bg">
          <fieldset className="search-bx">
            <div className="material">
              <input
                id=""
                type="text"
                placeholder="Search Agency"
                name="RoleName"
                className="form-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <i className="ic-search"></i>
            </div>
          </fieldset>
          <div className="sales-user-list">
            <ul>
  {filteredUsers.length > 0 ? (
    filteredUsers.map((user) => (
      <li key={user.value}>
        <label>
          {user.label} ({user.value})
          <span>{user.users.length} Mapped
             <span
          onClick={(e) => {
            e.stopPropagation();
            setOpenTooltipId(user.value); 
          }}
          className="tooltio-ic"
          data-tooltip-id={`mapped-tooltip-${user.value}`}
        >
          <i className="ic-info-icon1"></i>
        </span>

             </span>
        </label>
        <i
          className="ic-arrow_forward listclose-ic"
          onClick={() => handleMapUser(user)}
        ></i>

        {openTooltipId === user.value && (
          <div className='tooltip-outer'>
          <TooltipLite
            isOpen={openTooltipId === user.value}
            id={`mapped-tooltip-${user.value}`}
            place="right"
            clickable={true}
            className="react-tooltip-lite"
            render={() => (
              <div className="controlled-example tooltip-main">
                <div className="tooltip-data">
                  <span
                    className="controlled-example_close-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenTooltipId(null);
                    }}
                  >
                    <i className="ic-clearclose"></i>
                  </span>

                  <ul className="user-detail mappUserIcon">
                    {user.users.length > 0 ? (
                      user.users.map((mappedUser:any) => (
                        <li key={mappedUser.id}>
                          <label>{mappedUser.name} ({mappedUser.id})</label>
                        </li>
                      ))
                    ) : (
                      <li>
                        <span>No Mapped User</span>
                      </li>
                    )}
                  </ul>

                </div>
              </div>
            )}
          />
          </div>
        )}
      </li>
    ))
  ) : (
    <li>No Agency User Found</li>
  )}
</ul>
          </div>
        </div>
      </div>

      <div className="mapped-users-right-panel">
        <h3>Mapped Agencies</h3>
        <div className="sales-mapped-bg">
          <fieldset className="search-bx">
            <div className="material">
              <input
                id=""
                type="text"
                placeholder="Search Agency"
                name="RoleName"
                className="form-input"
                value={searchTermRight}
                onChange={(e) => setSearchTermRight(e.target.value)}
              />
              <i className="ic-search"></i>
            </div>
          </fieldset>

          <div className="sales-user-list">
            <ul className='scrollData'>
              {filteredMappedUsers.length > 0 ? (
                filteredMappedUsers.map((user) => (
                  <li key={user.value}>
                    <label>
                      {user.label} ({user.value})
                    </label>

                    {/* <button>X</button> */}
                    {/* <button onClick={() => handleUnmapUser(user)}>X</button> */}
                    <i className="ic-clearclose listclose-ic" onClick={() => handleUnmapUser(user)}></i>
                  </li>
                ))
              ) : (
                <li>No Mapped Users</li>
              )}
            </ul>

          </div>
        </div>
      </div>

      <div className="mapped-users-right-panel" style={{ display: 'none' }}>
        <h3>Mapped Sales Users</h3>
        <div className="sales-mapped-bg">
          <div className="sales-user-list no-data-txt">
            <ul>
              <li>Move Agent, BRO here</li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SalesMappedUser;
